"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross2"));
var _lock = _interopRequireDefault(require("cccisd-icons/lock4"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark4"));
var _menu = _interopRequireDefault(require("cccisd-icons/menu7"));
var _cccisdReactRouter = require("cccisd-react-router");
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdSideMenu = _interopRequireDefault(require("cccisd-side-menu"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var CurriculumTabs = function CurriculumTabs(_ref) {
  var basePath = _ref.basePath,
    currTab = _ref.currTab,
    currentTabs = _ref.currentTabs,
    assignmentLabel = _ref.label;
  var history = (0, _cccisdReactRouter.useHistory)();
  var desktopTrigger = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (desktopTrigger && desktopTrigger.current) {
      desktopTrigger.current.style.top = "calc(50vh - ".concat(desktopTrigger.current.offsetHeight / 2, "px)");
    }
  }, [desktopTrigger, desktopTrigger.current]);
  var trigger = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].mobileTrigger
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-primary",
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_menu["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].desktopTrigger,
    ref: desktopTrigger
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-primary",
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].vertical
  }, assignmentLabel))));
  function renderTabs(_ref2) {
    var closeNavigation = _ref2.closeNavigation;
    return /*#__PURE__*/_react["default"].createElement("ul", {
      className: "nav nav-pills nav-stacked"
    }, currentTabs.map(function (tab, i) {
      var _classnames;
      return /*#__PURE__*/_react["default"].createElement("li", {
        role: "presentation",
        key: i,
        className: (0, _classnames2["default"])((_classnames = {
          active: tab.tab === currTab,
          disabled: tab.isDisabled
        }, _defineProperty(_classnames, _style["default"].locked, tab.isLocked), _defineProperty(_classnames, _style["default"].complete, tab.isComplete), _classnames))
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "#",
        onClick: function onClick() {
          if (tab.isDisabled) {
            return;
          }
          history.push("".concat(basePath, "/").concat(tab.tab));
          closeNavigation();
        }
      }, tab.isLocked && /*#__PURE__*/_react["default"].createElement(_lock["default"], {
        spaceRight: true
      }), tab.isComplete && /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-success"
      }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], {
        spaceRight: true
      })), tab.tabName));
    }));
  }
  function renderCloseButton(_ref3) {
    var closeNavigation = _ref3.closeNavigation;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].menuTop
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].label
    }, assignmentLabel), /*#__PURE__*/_react["default"].createElement("button", {
      className: "btn btn-xs btn-default",
      type: "button",
      onClick: closeNavigation
    }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)));
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdSideMenu["default"], {
    renderTabs: renderTabs,
    trigger: trigger,
    renderCloseButton: renderCloseButton
  });
};
CurriculumTabs.propTypes = {
  basePath: _propTypes["default"].string,
  currentTabs: _propTypes["default"].array,
  currTab: _propTypes["default"].string,
  label: _propTypes["default"].string,
  location: _propTypes["default"].object
};
var _default = CurriculumTabs;
exports["default"] = _default;